<template>
  <div class="jump-to-top"
       :class="classes">
    <a v-scroll-to="'body'"
       href="#"
       class="jump-to-top__link"
       title="Jump to top"
       aria-label="Jump to top">
      <font-awesome-icon icon="arrow-to-top"></font-awesome-icon>
    </a>
  </div>
</template>

<script>
import Vue from "vue";
import VueScrollTo from "vue-scrollto";

Vue.use( VueScrollTo, {
  container: "#app",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
} );

export default {
  name: "JumpToTop",
  data: () => ( {
    scrollInstance: null,
    hidden: false,
    element: null
  } ),
  computed: {
    classes () {
      const result = [];

      if ( this.hidden ) {
        result.push( "jump-to-top--hidden" );
      }

      return result;
    }
  },
  mounted () {
    this.element = document.querySelector( "#app" );

    this.scrollHandler();

    this.scrollInstance = this.element.addEventListener( "scroll", () => {
      this.scrollHandler();
    }, { passive: true } );
  },
  beforeDestroy () {
    if ( this.element ) {
      this.element.removeEventListener( "scroll", this.scrollInstance );
    }
  },
  methods: {
    scrollHandler () {
      const { scrollTop = 0 } = this.element;

      this.hidden = scrollTop < 100;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../Styles/utils/colors.less";

.jump-to-top {
  z-index: 600;
  display: flex;
  text-align: center;
  position: fixed;
  bottom: 20px;
  right: 40px;
  justify-content: center;
  align-items: center;
  opacity: 1;
  transition: opacity 0.2s;
  background: @color-accent-8;
  border-radius: 5px;

  .jump-to-top__link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    flex-grow: 1;
    font-size: 2rem;
    color: #fff;

    &:hover {
      color: #eee;
    }
  }

  &--hidden {
    opacity: 0;
  }

  @media print {
    display: none;
  }

  @media ( min-width: 992px ) {
    display: none;
  }
}
</style>
